import { useEffect } from 'react'
import { useLazyQuery, gql } from '@apollo/client'

import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import List from 'components/v2/List'
import { Input } from 'components/Input'
import { Row } from '@10xLabs/react-web/components/Row'
import { Column } from '@10xLabs/react-web/components/Column'

const GET_LINES_BY_COMPANY = gql`
  query GetLinesByCompany($limit: Int, $companyId: ID) {
    companyLines(input: { limit: $limit, companyID: $companyId }) {
      id
      name
    }
  }
`

const SelectLinesWrapper = styled.div<TSFixMe>`
  display: flex;
  justify-content: space-between;
`

const ListWrapper = styled.div<TSFixMe>`
  flex: 1 0 45%;
  width: 0;
  border: 1px solid #9999bd;
  overflow: hidden;
  border-radius: 3px;
  min-height: 100px;
`

const SwitchWrapper = styled.div<TSFixMe>`
  align-self: center;
  padding: 10px;
`

export const SelectLinesByCompany = (props: TSFixMe): TSFixMe => {
  let content
  const [getLinesByCompany, { loading, error, data }] = useLazyQuery(GET_LINES_BY_COMPANY)

  useEffect((): TSFixMe => {
    if (props.companyId) {
      props.onChange([])
      getLinesByCompany({
        variables: {
          companyId: props.companyId,
          limit: 1000
        }
      })
    }
  }, [props.companyId])

  useEffect((): TSFixMe => {
    if (data && data.companyLines && data.companyLines.length === 1) {
      props.onChange([data.companyLines[0]])
    }
  }, [data])

  const addLine = (line: TSFixMe): TSFixMe => {
    props.onChange([...props.values, line])
  }

  const removeLine = (line: TSFixMe): TSFixMe => {
    props.onChange(props.values.filter(({ id }: TSFixMe): TSFixMe => line.id !== id))
  }

  if (loading) {
    content = <FormattedMessage id="dictionary.loading" defaultMessage="Loading..." />
  } else if (error) {
    content = <FormattedMessage id="dictionary.error" defaultMessage="Error..." />
  } else if (!props.companyId || !data) {
    content = <FormattedMessage id="company.notSelected" defaultMessage="No company selected" />
  } else if (data.companyLines.length === 0) {
    content = <FormattedMessage id="lines.empty" defaultMessage="No lines available" />
  } else if (data.companyLines.length === 1) {
    content = (
      <Row>
        <Column>
          <Input value={data.companyLines[0].name} readOnly />
        </Column>
      </Row>
    )
  } else {
    const availableLines = data.companyLines.filter(({ id }: TSFixMe): TSFixMe => {
      const selectedLinesId = props.values.map((line: TSFixMe): TSFixMe => line.id)
      return selectedLinesId.indexOf(id) === -1
    })

    content = (
      <SelectLinesWrapper>
        <ListWrapper>
          <List.Container>
            {availableLines.map((line: TSFixMe): TSFixMe => {
              return (
                <List.Item key={line.id} onClick={addLine.bind(this, line)} action>
                  {line.name}
                </List.Item>
              )
            })}
          </List.Container>
        </ListWrapper>

        <SwitchWrapper>
          <div>{'->'}</div>

          <div>{'<-'}</div>
        </SwitchWrapper>

        <ListWrapper>
          <List.Container>
            {props.values.map((line: TSFixMe): TSFixMe => {
              return (
                <List.Item key={line.id} onClick={removeLine.bind(this, line)} action>
                  {line.name}
                </List.Item>
              )
            })}
          </List.Container>
        </ListWrapper>
      </SelectLinesWrapper>
    )
  }
  return <div>{content}</div>
}
